"use client";

import CustomSocialButton from "@/app/(protected)/components/forms/theme-elements/CustomSocialButton";
import { signInType } from "@/app/(protected)/types/auth/auth";
import { DEFAULT_LOGIN_REDIRECT } from "@/routes";
import { Avatar, Box } from "@mui/material";
import { Stack } from "@mui/system";
import { signIn } from "next-auth/react";
import { useSearchParams } from "next/navigation";

export const AuthSocialButtons = ({ title }: signInType) => {
  const searchParams = useSearchParams();
  const callbackUrl = searchParams.get("callbackUrl");

  const onClick = (provider: "google") => {
    signIn(provider, {
      callbackUrl: callbackUrl || DEFAULT_LOGIN_REDIRECT,
    });
  };

  return (
    <Stack direction="row" justifyContent="center" spacing={2} mt={3}>
      <CustomSocialButton
        sx={{
          borderColor: '#e5e7eb',
          color: '#0f172a',
          '&:hover': {
            borderColor: '#10b981',
            backgroundColor: 'rgba(16, 185, 129, 0.04)',
            transform: 'translateY(-2px)',
            transition: 'all 0.3s ease',
            color: '#0f172a',
          },
        }}
      >
        <Avatar
          src={"/images/svgs/google-icon.svg"}
          alt={"google"}
          sx={{
            width: 16,
            height: 16,
            borderRadius: 0,
            mr: 1,
          }}
        />
        <Box
          sx={{
            display: { xs: "none", sm: "flex" },
            whiteSpace: "nowrap",
            mr: { sm: "3px" },
            color: "#0f172a",
          }}
          onClick={() => onClick("google")}
        >
          {title}{" "}
        </Box>
        <Box component="span" sx={{ color: "#0f172a" }}>
          {"Google"}
        </Box>
      </CustomSocialButton>
    </Stack>
  );
};
